<template>
  <div style="background-color: #f5f5f5">
    <div style="margin-left: 10%;padding-left:80px;padding-top:50px;margin-top: 70px;background-color: #ffffff;width: 80%;padding-bottom: 50px">
      <h1>{{mainData.name}}</h1>
      <p style="padding-top: 20px">该壁纸已被浏览{{data.clickCount}}次</p>
      <p style="padding-top: 20px">发布于  {{mainData.date}}</p>
      <p style="padding-top: 20px">动态壁纸  /  {{mainData.category_name}}</p>
      <p style="padding-top: 20px;padding-bottom: 30px">{{mainData.tags}}</p>
      <row>
        <Col span="5" style="text-align: center">
          <video controls :src="mainData.url" width="400px" style="margin: 10px"></video>
          <Button target="_blank" size="large" icon="ios-download-outline" :to="mainData.url+'?download'" ghost type="info" style="margin-top: 20px;margin-left: 100px">下载</Button>
        </Col>
        <Col span="8" offset="8">
          <h2 style="">热门下载</h2>
          <video v-for="(i,index) in data.hot" preload="metadata" @click="clickImage(i.id)" :key="i.id" muted onMouseOver="this.play()" onMouseOut="this.pause()" :src="i.url" width="200px" style="margin: 10px"></video>
        </Col>
      </row>
    </div>
    <div style="margin-top: 40px;margin-left: 10%;background-color: #ffffff;text-align: center;width: 80%;">
      <h1 style="padding: 40px 0 0 0">您可能对以下的也感兴趣</h1>
      <h3 style="padding: 10px 0 0 0">You may be interested</h3>
      <video v-for="(i,index) in data.guess" preload="metadata" @click="clickImage(i.id)" :key="i.id" muted onMouseOver="this.play()" onMouseOut="this.pause()" :src="i.url" width="200px" style="margin: 10px"></video>

    </div>
  </div>
</template>

<script>
  import {ajaxFetch} from '../utils'
  export default {
    name: 'DetailMp4Page',
    data () {
      return {
        data: {},
        mainData: {},
        id: ''
      }
    },
    mounted: function () {
      this.id = this.$route.query.id
      this.listByCategory(this.id)
    },
    methods: {
      listByCategory: function (id) {
        ajaxFetch('post','/client/productTable/findById',{id: id},(response) => {
          if (response.code === 200) {
            this.data = response.data
            this.mainData = this.data.main
          } else {

          }
        }, (err) => {
          console.log(err)
        } )
      },
      clickImage: function (id) {
        this.$router.push({name: 'detailMp4Page', query: {id: id}})
      },
      playVideo: function (val) {
        console.log(val)
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/DetailMp4Page.vue